<div class="flex flex-col flex-auto" id="wellManagementIndex">
    <div class="row justify-between px-6 py-3 card-header">
        <div class="text-lg font-medium tracking-tight leading-6 truncate">
            Total Well Management Monitoring Index
        </div>
        <button
            (click)="
                openDialog(
                    'Total Well Management Monitoring Index',
                    'wellManagementIndex',
                    'createRadarChart'
                )
            "
        >
            <ng-container [ngTemplateOutlet]="expandIcon"></ng-container>
        </button>
    </div>

    <div class="px-6 pb-6 pt-2">
        <div style="height: 400px" id="radarChart"></div>

        <div class="pt-2">
            <ul>
                <li *ngFor="let kpi of kpiList">
                    KPI {{ kpi.kpiNumber }}:
                    {{
                        formatKpiDisplay(
                            kpi.title || kpi.kpiTitle,
                            kpi.baselinePercentage || 0
                        )
                    }}
                </li>
            </ul>
        </div>
    </div>
</div>
